import { render, staticRenderFns } from "./KmIcon.vue?vue&type=template&id=009a24aa&scoped=true&"
import script from "./KmIcon.vue?vue&type=script&lang=js&"
export * from "./KmIcon.vue?vue&type=script&lang=js&"
import style0 from "./KmIcon.vue?vue&type=style&index=0&id=009a24aa&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009a24aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/unitech/keymetrics/pm2-io/keymetrics/pm2-io-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('009a24aa')) {
      api.createRecord('009a24aa', component.options)
    } else {
      api.reload('009a24aa', component.options)
    }
    module.hot.accept("./KmIcon.vue?vue&type=template&id=009a24aa&scoped=true&", function () {
      api.rerender('009a24aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/KmIcon.vue"
export default component.exports